// Create AudioContext once (after a user click)
let audioContext;
let nextStartTime = 0;

export const initAudioContext = async () => {
  if (!audioContext) {
    audioContext = new (window.AudioContext || window.webkitAudioContext)();
  }
  
  // On iOS, the audio context must be resumed after user interaction
  if (audioContext.state === 'suspended') {
    try {
      await audioContext.resume();
      console.log('🎵 Audio context resumed successfully');
    } catch (error) {
      console.error('Failed to resume audio context:', error);
    }
  }
  
  return audioContext;
};

// Play audio chunk
export const playAudioChunk = async (audioChunk, isAudioMuted) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (isAudioMuted) {
        resolve();
        return;
      }

      // Ensure audio context is initialized
      if (!audioContext) {
        await initAudioContext();
      }

      // Resume audio context if suspended (iOS requirement)
      if (audioContext.state === 'suspended') {
        try {
          await audioContext.resume();
          console.log('🎵 Audio context resumed in playAudioChunk');
        } catch (error) {
          console.error('Failed to resume audio context in playAudioChunk:', error);
          reject(error);
          return;
        }
      }

      // Convert base64 to ArrayBuffer
      const binaryString = atob(audioChunk.data);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      const arrayBuffer = bytes.buffer;

      // Decode audio data
      const decodedData = await audioContext.decodeAudioData(arrayBuffer);

      // Create buffer source
      const source = audioContext.createBufferSource();
      source.buffer = decodedData;
      source.connect(audioContext.destination);

      // Queue playback smoothly
      if (nextStartTime < audioContext.currentTime) {
        nextStartTime = audioContext.currentTime + 0.05;
      }
      source.start(nextStartTime);
      nextStartTime += source.buffer.duration;

      source.onended = () => resolve();

    } catch (error) {
      console.error("Error playing audio chunk:", error);
      reject(error);
    }
  });
};

// Clean up audio context
export const cleanupAudioContext = () => {
  if (audioContext && audioContext.state !== 'closed') {
    audioContext.close();
    audioContext = null;
  }
  nextStartTime = 0;
};
